export class SfxPool {
  private readonly buffers = new Map<string, AudioBuffer>();

  constructor(
    private readonly context: BaseAudioContext,
    private readonly destination: AudioNode,
  ) {}

  register(name: string, buffer: AudioBuffer): void {
    this.buffers.set(name, buffer);
  }

  has(name: string): boolean {
    return this.buffers.has(name);
  }

  get size(): number {
    return this.buffers.size;
  }

  play(name: string): boolean {
    const buffer = this.buffers.get(name);
    if (buffer === undefined) return false;
    const source = this.context.createBufferSource();
    source.buffer = buffer;
    source.connect(this.destination);
    source.start();
    return true;
  }

  dispose(): void {
    this.buffers.clear();
  }
}
